import * as FS from '@fullstory/browser';
import { AppEnv, type Environment } from '#app/shared/contexts/AppContext';
import type { AuthContextResult } from '#app/shared/contexts/AuthContext';
import type { EventData } from './eventPublishing';

export const initializeFullStory = (environment: Environment) => {
  // initialize FullStory
  FS.init({ orgId: '14PRCC', devMode: environment.APP_ENV !== AppEnv.PROD });
};

/**
 * Set the user with FullStory.
 * @param authContext
 */
export const fullstorySetUser = (authContext: AuthContextResult) => {
  // update the FullStory identity
  const fullStoryCustomVars = {
    ...authContext.externalContext,
    // https://help.fullstory.com/hc/en-us/articles/360020828113-FS-identify-Identifying-users#displayname
    displayName: authContext.userFullName,
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  } as any;
  FS.FullStory('setIdentity', {
    uid: authContext.userKey,
    properties: fullStoryCustomVars,
  });
};

/*
 * @param eventName The event name must be in PascalCase
 * @param eventProperties A dictionary with key-value pairs, The "keys" must be in camelCase.
 */
export function publishFSCustomEvent(
  eventName: string,
  eventProperties: EventData,
) {
  try {
    FS.FullStory('trackEvent', {
      name: eventName,
      properties: eventProperties,
    });
  } catch (e) {
    console.log('Failed to publish fullstory custom event', e);
  }
}
